import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
/**
 * Guarda un valor de utilidad
 */
declare var $: any;
/**
 * Componente para el loader genérico de gestión de cuenta y mostrar datos relevantes de la cuenta
 */
@Component({
  standalone: false,
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() headerFooter: boolean;
  @Input() isRapidScoreForce: boolean;
  country: string;
  language: string;
  /**
   * Guarda el listado de kpis
   */
  kpis: any = [];
  /**
   * Guarda el número de kpis
   */
  count = 1;
  /**
   * Mensaje a mostrar al usuario
   */
  message: string;

  /**
   * Determines whether rapid score is
   */
  isRapidScore: boolean;

  /**
   * Crea una instancia para loading component.
   * @param translate
   */
  constructor(private translate: TranslateService) { }

  /**
   * Devuelve del archivo de traducciones el listado de kpis
   */
  ngOnInit() {
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
    this.isRapidScore = !!JSON.parse(sessionStorage.getItem('getParams')) || this.isRapidScoreForce;
    this.translate.get(['LOADING.KPI']).subscribe(data => {
      this.kpis = data['LOADING.KPI'];
      this.changeKPIs();
    });
  }

  /**
   * Cambia los kpis mostrados con animación
   */
  changeKPIs() {
    this.message = this.kpis[this.count];
    $('#fadeIn').fadeOut(3000, () => {
      this.count = (this.count === Object.keys(this.kpis).length) ? 0 : this.count;
      this.message = this.kpis[++this.count];
      $('#fadeIn').fadeIn(3000, () => {
        this.changeKPIs();
      });
    });
  }

}
